module.exports = __webpack_public_path__ + "static/media/bd4.5317e767.jpg";